import React, { useEffect, useState } from 'react';
import { VerificationPacketDocumentPicker } from './verification-packet-document-picker';
import { useLazyQuery, useMutation } from '@apollo/client';
import {
  FileInfo,
  CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerCredentialVerificationCaseV1Document,
  CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerCredentialVerificationCaseV1MergePdfFilesDocument,
  FileInfoInput
} from '../../../../../../generated';
import { ComponentQueryLoader } from '../../../../../shared/component-query-loader';
import { message } from 'antd';

interface VerificationPacketDocumentPickerContainerProps {
  onMergePdfComplete: () => Promise<void>;
  verificationFileNames: Map<string, string>;
  verificationFileName: string;
  caseId: string;
  onCancel: () => void;
}

export const VerificationPacketDocumentPickerContainer: React.FC<VerificationPacketDocumentPickerContainerProps> = (props) => {
  const [isProcessingMergingPdfs, setIsProcessingMergingPdfs] = useState(false);

  const [getFilesData, { data: fileData }] = useLazyQuery(CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerCredentialVerificationCaseV1Document, {
    fetchPolicy: 'network-only'
  });

  const [mergeAndUploadPdfFiles] = useMutation(CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerCredentialVerificationCaseV1MergePdfFilesDocument);

  const fetchFilesData = async () => {
    await getFilesData({
      variables: {
        credentialVerificationCaseV1Id: props.caseId
      }
    });
  };

  useEffect(() => {
    fetchFilesData();
  }, []);

  const blobUrls: FileInfo[] = [
    {
      name: '',
      url: '',
      type: '',
    },
    { name: '', url: '', type: '' },
    { name: '', url: '', type: '' }
  ];

  fileData?.credentialVerificationCaseV1?.files?.filter((file) => {
    const fileName = file?.name?.split('/').pop();
    if (fileName === props.verificationFileNames.get('verificationForm')) {
      blobUrls[0] = {
        url: file?.url ?? '',
        name: file?.name ?? 'verification-form.pdf',
        type: file?.type ?? ''
      };
    } else if (fileName === props.verificationFileNames.get('credential')) {
      blobUrls[1] = {
        url: file?.url ?? '',
        name: file?.name ?? 'credential',
        type: file?.type ?? ''
      };
    } else if (fileName === props.verificationFileNames.get('redactedNotarizedIdForm')) {
      blobUrls[2] = {
        url: file?.url ?? '',
        name: file?.name ?? 'redacted-notarized-id-form.pdf',
        type: file?.type ?? ''
      };
    }
    return props.verificationFileNames.get('credential') ?? props.verificationFileNames.get('verificationForm') ?? props.verificationFileNames.get('redactedNotarizedIdForm');
  });

  const handleMergePdfs = async (blobPaths: FileInfoInput[]) => {
    setIsProcessingMergingPdfs(true);
    mergeAndUploadPdfFiles({
      variables: {
        input: {
          blobPaths: blobPaths,
          caseId: props.caseId,
          fileName: props.verificationFileName
        }
      }
    }).then(async (res) => {
      if (res.data?.credentialVerificationCaseV1MergePdfFiles?.status.success) {
        await props.onMergePdfComplete();
      } else {
        message.error('Error merging PDFs');
      }
      setIsProcessingMergingPdfs(false);
    });
  };

  const handleCancel = () => {
    props.onCancel();
  }
  return (
    <ComponentQueryLoader
      loading={!fileData}
      hasData={fileData}
      hasDataComponent={
        <VerificationPacketDocumentPicker
          onCancel={handleCancel}
          isProcessingMergingPdfs={isProcessingMergingPdfs}
          onMergePdfs={handleMergePdfs}
          blobUrls={blobUrls}
          verificationFileNames={props.verificationFileNames}
        />
      }
    />
  );
};
